import { computed } from "vue";
import { useAuthStore } from "../../stores/auth";
import { TwinResponse } from "@shared/services/twinManagement";
import { clientId, roles } from "../constants";
import { TicketManagementAuth } from "@shared/maintenance/hooks/maintenanceAuth";

export function useProcessMiningTicketAuth(): TicketManagementAuth {
  const authStore = useAuthStore();

  // TODO: backend currently does not support groups, for now we just check for admin role

  function isTicketTypeProcessor(ticket: TwinResponse) {
    return (
      authStore.rolesByClientId?.[clientId]?.roles.includes(roles.admin) ||
      authStore.isSuperAdmin ||
      false
    );
  }

  function isTicketTypeManager(ticket: TwinResponse) {
    return (
      authStore.rolesByClientId?.[clientId]?.roles.includes(roles.admin) ||
      authStore.isSuperAdmin ||
      false
    );
  }

  function isPlanner(ticket: TwinResponse) {
    return (
      authStore.rolesByClientId?.[clientId]?.roles.includes(roles.planner) ||
      authStore.isSuperAdmin ||
      false
    );
  }

  function isAdmin() {
    return (
      authStore.rolesByClientId?.[clientId]?.roles.includes(roles.admin) ||
      authStore.isSuperAdmin ||
      false
    );
  }

  function isTicketCreator() {
    return (
      authStore.rolesByClientId?.[clientId]?.roles.includes(
        roles.ticketCreator,
      ) || false
    );
  }

  function isUser() {
    return (
      authStore.rolesByClientId?.[clientId]?.roles.includes(roles.user) || false
    );
  }
  return {
    isTicketTypeManager,
    isTicketTypeProcessor,
    isPlanner,
    isAdmin,
    isUser,
    isTicketCreator,
  };
}
